<h1 *ngIf="currentUser" class="text-gray-500">Welcome {{currentUser.name}}</h1>
